import { getTypedObjectKeys } from '@pkg/types';

import { ImageAgain, ImageBack, ImageDarkness, ImageDead, ImageDevs, ImagePour, ImageWhat } from './images';
import { type FloorActivityMemeCollection, FloorActivityMemeId } from './types';

export const memeCollection: FloorActivityMemeCollection = {
    [FloorActivityMemeId.Again]: {
        labelKey: 'meme_label_again',
        image: ImageAgain,
    },
    [FloorActivityMemeId.Back]: {
        labelKey: 'meme_label_back',
        image: ImageBack,
    },
    [FloorActivityMemeId.Darkness]: {
        labelKey: 'meme_label_darkness',
        image: ImageDarkness,
    },
    [FloorActivityMemeId.Dead]: {
        labelKey: 'meme_label_dead',
        image: ImageDead,
    },
    [FloorActivityMemeId.Devs]: {
        labelKey: 'meme_label_devs',
        image: ImageDevs,
    },
    [FloorActivityMemeId.Pour]: {
        labelKey: 'meme_label_pour',
        image: ImagePour,
    },
    [FloorActivityMemeId.What]: {
        labelKey: 'meme_label_what',
        image: ImageWhat,
    },
};

export const memeIds = getTypedObjectKeys(memeCollection);
